module.exports = __webpack_public_path__ + "img/section3.a8fbc037.png";